export const getDataFromLocal = (key) => {
  return localStorage.getItem(key)
}

export function setLocalStorage(parentKey, childKey, value) {
  let localData = localStorage.getItem('admin')
    ? JSON.parse(localStorage.getItem('admin'))
    : {}
  localData = {
    ...localData,
    [parentKey]: { ...localData[parentKey], [childKey]: value },
  }
  localStorage.setItem('admin', JSON.stringify(localData))
}

export function getLocalStorage(parentKey, childKey) {
  let localData = JSON.parse(localStorage.getItem('admin')) || {}
  return localData[parentKey]?.[childKey]
}

// export const failResponse = (res) => {
//   toast.error(res.data?.message || res.message, { id: "fail" });
// };

// export const errorResponse = (err) => {
//   toast.error(err?.response?.data?.message || err.message);
// };
